import { render, staticRenderFns } from "./EditCoverText.vue?vue&type=template&id=28989931&scoped=true&"
import script from "./EditCoverText.vue?vue&type=script&lang=js&"
export * from "./EditCoverText.vue?vue&type=script&lang=js&"
import style0 from "./EditCoverText.vue?vue&type=style&index=0&id=28989931&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28989931",
  null
  
)

export default component.exports